import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllDrugOrderDataService = async (
  pageNumber,
  pageSize,
  access_token,
  searchedDrugOrder = "",
  userId
) => {
  try {
    return axios.get(
      `${api}/DrugOrder/GetDepotToDepotOrdersPagination?UserId=${userId}&pageNumber=${
        searchedDrugOrder !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${searchedDrugOrder}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchAllSiteDrugOrders = async (
  pageNumber,
  pageSize,
  access_token,
  searchedDrugOrder = "",
  userId
) => {
  try {
    return axios.get(
      `${api}/DrugOrder/GetDepotToSiteOrders?UserId=${userId}&pageNumber=${
        searchedDrugOrder !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${searchedDrugOrder}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getDrugOrderOnloadDataService = async (
  access_token,
  depotId = "",
  userId
) => {
  try {
    return axios.get(
      `${api}/DrugOrder/GetOnloadData?DepotId=${depotId}&UserId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getLotsDataService = async (
  access_token,
  depotId = "",
  siteId = ""
) => {
  try {
    return axios.get(
      `${api}/DrugOrder/GetLots?DepotID=${depotId}&SiteId=${siteId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getLotsDrugDataService = async (
  access_token,
  lotId,
  depotId = "",
  siteId = ""
) => {
  try {
    return axios.get(
      `${api}/DrugOrder/GetDrugItems?Id=${lotId}&DepotID=${depotId}&SiteId=${siteId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getSequenceDrugsDataService = async (
  access_token,
  depotId = "",
  siteId = ""
) => {
  try {
    return axios.get(
      `${api}/DrugOrder/GetSequenceDrugItems?DepotID=${depotId}&SiteId=${siteId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const placeDrugOrderService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DrugOrder/PlaceOrder`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const validateSequenceRangesService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DrugOrder/DrugRangeValidation`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const getCancelOrderOnLoadDataService = async (
  access_token,
  orderId
) => {
  try {
    return axios.get(
      `${api}/CancelOrder/GetCancelOrderOnload?orderId=${orderId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const cancelOrderService = async (access_token, data, userId) => {
  try {
    return axios.post(
      `${api}/CancelOrder/PostCancelOrder?UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getAcknowledgeOrderOnLoadDataService = async (
  access_token,
  orderId
) => {
  try {
    return axios.get(
      `${api}/AcknowledgeOrder/AcknowledgeOrderOnload?orderId=${orderId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getDrugKitDataService = async (
  access_token,
  orderId,
  page,
  pageSize,
  siteDestinationId = null,
  selectedDrugStatusIdForAll = null
) => {
  try {
    let url = `${api}/AcknowledgeOrder/GetDrugsForOrderGrid?orderId=${orderId}`;
    if (siteDestinationId !== null) {
      url += `&siteDestinationId=${siteDestinationId}`;
    }
    if (selectedDrugStatusIdForAll !== null) {
      url += `&selectedDrugStatusIdForAll=${selectedDrugStatusIdForAll}`;
    }
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const acknowledgeDrugOrderService = async (
  access_token,
  data,
  userId
) => {
  try {
    return axios.post(
      `${api}/AcknowledgeOrder/PostSimpleAcknowledgeOrder?UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getDetaiSiteAcknowledgeDataService = async (
  access_token,
  orderId
) => {
  try {
    return axios.get(
      `${api}/AcknowledgeOrder/DetailedAckOnload?orderId=${orderId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const checkAcknowledgmentTypeService = async (access_token) => {
  try {
    return axios.get(`${api}/DrugOrder/GetDrugAckType`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const getShipperDrugDataService = async (
  access_token,
  orderId,
  alreadyAssignedJson
) => {
  try {
    const assignedJsonParam =
      alreadyAssignedJson && alreadyAssignedJson.length === 0
        ? JSON.stringify([])
        : alreadyAssignedJson;
    return axios.get(
      `${api}/AcknowledgeOrder/LoadDrugsForModel?orderId=${orderId}&alreadyAssignedJson=${assignedJsonParam}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const postDetaileAcknowledgmentService = async (
  access_token,
  pluralKitAlias,
  data,
  userId
) => {
  try {
    return axios.post(
      `${api}/AcknowledgeOrder/PostDetailedAcknowledgeOrder?PluralKitAlias=${pluralKitAlias}&userId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const parseShipperRowService = async (access_token, data) => {
  try {
    return axios.post(`${api}/AcknowledgeOrder/ParseShipperRow`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const getQuarantineOnLoadData = async (access_token, orderId) => {
  try {
    return axios.get(
      `${api}/QuarantineApproval/GetQuarantineDataOnload?orderId=${orderId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const getQuarantineDrugDataService = async (
  access_token,
  orderId,
  siteDestinationId = null,
  selectedDrugStatusIdForAll = null,
  updateJson = []
) => {
  try {
    let url = `${api}/QuarantineApproval/GetDrugsForOrderGrid?orderId=${orderId}&updateJson=${JSON.stringify(
      updateJson
    )}`;
    if (siteDestinationId !== null) {
      url += `&siteDestinationId=${siteDestinationId}`;
    }
    if (selectedDrugStatusIdForAll !== null) {
      url += `&selectedDrugStatusIdForAll=${selectedDrugStatusIdForAll}`;
    }
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const processQuarantineService = async (access_token, data, userId) => {
  try {
    return axios.post(
      `${api}/QuarantineApproval/PostQuarantineApproval?UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};
